var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-0 d-flex",attrs:{"id":"init-home-container"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-spacer'),_c('titlecard'),_c('v-spacer'),_c('image_gallery'),_c('v-spacer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }